// extracted by mini-css-extract-plugin
module.exports = {"functionBadge":"styles_functionBadge__zvIKT","functionRow":"styles_functionRow__4WMxO"};